var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2937_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9905 6.99916C13.9905 3.17462 10.8901 0.0742188 7.06556 0.0742188C3.24102 0.0742188 0.140625 3.17462 0.140625 6.99916C0.140625 10.4555 2.67296 13.3205 5.98354 13.84V9.0009H4.22526V6.99916H5.98354V5.47351C5.98354 3.73794 7.01741 2.77927 8.5992 2.77927C9.35661 2.77927 10.1493 2.91453 10.1493 2.91453V4.61871H9.27614C8.41593 4.61871 8.14759 5.15255 8.14759 5.70073V6.99916H10.0682L9.76115 9.0009H8.14759V13.84C11.4582 13.3205 13.9905 10.4555 13.9905 6.99916Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75855 8.99897L10.0656 6.99723H8.14498V5.6988C8.14498 5.15116 8.41333 4.61678 9.27353 4.61678H10.1467V2.9126C10.1467 2.9126 9.35428 2.77734 8.59659 2.77734C7.01481 2.77734 5.98094 3.73602 5.98094 5.47158V6.99723H4.22266V8.99897H5.98094V13.838C6.69793 13.9502 7.428 13.9502 8.14498 13.838V8.99897H9.75855Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2937_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8499,
    height: 13.8499,
    fill: "white",
    transform: "translate(0.140625 0.0742188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.435181b23fb85abe48ff7cdc6c9f1230.svg";
export { ForwardRef as ReactComponent };